import {
  Modal as ChakraModal,
  ModalProps as ChakraModalProps,
} from '@chakra-ui/react'

export type ModalProps = Omit<ChakraModalProps, 'colorScheme' | 'variant'>
// Chakra Modal creates a context and passes it to its children. Don't need to use data-qa or className here.

export const Modal = ({ ...chakraModalProps }: ModalProps) => {
  return (
    <ChakraModal
      allowPinchZoom={true}
      isCentered={true}
      {...chakraModalProps}
    />
  )
}

Modal.displayName = 'Modal'
